import createIcon from '../../createIcon';

/**
 * @component @name SingleBed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTJDMjAgMTAuOSAxOS4xIDEwIDE4IDEwVjdDMTggNS45IDE3LjEgNSAxNiA1SDhDNi45IDUgNiA1LjkgNiA3VjEwQzQuOSAxMCA0IDEwLjkgNCAxMlYxN0g1LjMzTDYgMTlIN0w3LjY3IDE3SDE2LjM0TDE3IDE5SDE4TDE4LjY3IDE3SDIwVjEyWk0xNiAxMEgxM1Y3SDE2VjEwWk04IDdIMTFWMTBIOFY3Wk02IDEySDE4VjE1SDZWMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SingleBed = createIcon('SingleBed', [
  [
    'path',
    {
      d: 'M20 12C20 10.9 19.1 10 18 10V7C18 5.9 17.1 5 16 5H8C6.9 5 6 5.9 6 7V10C4.9 10 4 10.9 4 12V17H5.33L6 19H7L7.67 17H16.34L17 19H18L18.67 17H20V12ZM16 10H13V7H16V10ZM8 7H11V10H8V7ZM6 12H18V15H6V12Z',
      key: 'vmz4ah',
    },
  ],
]);

export default SingleBed;
